import { render } from "./PwaInstructions.vue?vue&type=template&id=274486d4&scoped=true"
import script from "./PwaInstructions.vue?vue&type=script&lang=js"
export * from "./PwaInstructions.vue?vue&type=script&lang=js"

import "./PwaInstructions.vue?vue&type=style&index=0&id=274486d4&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_ambient/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274486d4"]])

export default __exports__